<template>
  <BaseIcon
    :width="width"
    :height="height"
    box="0 0 11 12"
    :color="color"
    title="Logo WhatsApp"
  >
    <!-- eslint-disable max-len -->
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.00220736 11L0.745807 8.26759C0.255833 7.42767 -0.00158985 6.47239 7.38773e-06 5.5C7.38773e-06 2.46235 2.46236 0 5.5 0C8.53765 0 11 2.46235 11 5.5C11 8.53764 8.53765 11 5.5 11C4.52803 11.0016 3.57317 10.7443 2.73351 10.2547L0.00220736 11ZM3.51505 2.9194C3.44403 2.92381 3.37463 2.94252 3.31101 2.9744C3.25134 3.00818 3.19688 3.05042 3.14931 3.0998C3.08331 3.16195 3.04591 3.21585 3.00576 3.2681C2.80248 3.53265 2.69314 3.85738 2.69501 4.191C2.69611 4.4605 2.76651 4.72285 2.87651 4.96815C3.10146 5.46425 3.47161 5.9895 3.96055 6.47625C4.07825 6.5934 4.1932 6.7111 4.31695 6.82055C4.92382 7.35485 5.64699 7.74017 6.42895 7.94585L6.7419 7.99369C6.84365 7.9992 6.9454 7.99149 7.0477 7.98654C7.20788 7.97828 7.36429 7.9349 7.50585 7.8595C7.57788 7.8224 7.64817 7.78202 7.7165 7.73849C7.7165 7.73849 7.74015 7.72309 7.78525 7.68899C7.8595 7.63399 7.90515 7.59495 7.96675 7.5306C8.0124 7.4833 8.052 7.42774 8.08225 7.3645C8.12515 7.27485 8.16805 7.1038 8.18565 6.96135C8.19885 6.85245 8.195 6.79305 8.19335 6.7562C8.19115 6.69735 8.1422 6.6363 8.08885 6.61045L7.76875 6.4669C7.76875 6.4669 7.29025 6.25845 6.9982 6.12535C6.96741 6.11192 6.93441 6.10428 6.90085 6.1028C6.86322 6.09893 6.8252 6.10317 6.78934 6.11521C6.75348 6.12726 6.72062 6.14684 6.69295 6.17265V6.17155C6.6902 6.17155 6.65335 6.2029 6.2557 6.6847C6.23288 6.71536 6.20144 6.73854 6.16539 6.75128C6.12935 6.76401 6.09033 6.76572 6.0533 6.7562C6.01747 6.74661 5.98236 6.73448 5.94825 6.7199C5.88005 6.6913 5.8564 6.6803 5.80965 6.65995L5.8069 6.65885C5.49225 6.52147 5.20093 6.33591 4.9434 6.10885C4.8741 6.04835 4.80975 5.98235 4.74375 5.91855C4.52737 5.71133 4.3388 5.4769 4.18275 5.22115L4.1503 5.1689C4.127 5.13379 4.10815 5.09591 4.0942 5.05615C4.0733 4.9753 4.12775 4.9104 4.12775 4.9104C4.12775 4.9104 4.2614 4.7641 4.32355 4.6849C4.3753 4.61907 4.42359 4.5506 4.4682 4.47975C4.5331 4.37525 4.55345 4.268 4.51935 4.18495C4.36535 3.80875 4.20585 3.4342 4.04195 3.0624C4.0095 2.9887 3.91325 2.9359 3.8258 2.92545C3.7961 2.92215 3.7664 2.91885 3.7367 2.91665C3.66284 2.91298 3.58883 2.91371 3.51505 2.91885V2.9194Z"
    />
  </BaseIcon>
</template>

<script>
import BaseIcon from './BaseIcon.vue';

export default {
  components: {
    BaseIcon,
  },
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
    width: {
      type: [Number, String],
      default: 72,
    },
    height: {
      type: [Number, String],
      default: 72,
    },
  },
};
</script>
